












import Vue from 'vue'
export default Vue.extend({
  name: 'IconKebab',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
})
